import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-loader",
	templateUrl: "./loader.component.html",
	styleUrls: ["./loader.component.scss"]
})
export class LoaderComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/layout/loader/loader.component.ts